import { useState } from "react";
import { Plus, Download, Check, X, UserPlus } from "lucide-react";
import StatusBadge from "../components/StatusBadge";

const credentialsData = [
  { id: "req-1", client: "Acme Corporation",     corporateName: "Acme Corporation Pvt Ltd",    panNumber: "ABCDE1234F", email: "admin@acmecorp.com",          phone: "+1 555 0100", submittedDate: "2026-03-01", panCopy: "Available", gstCertificate: "Available", tanCertificate: "Available", status: "Pending" },
  { id: "req-2", client: "Global Tech Solutions", corporateName: "Global Tech Solutions Inc",    panNumber: "FGHIJ5678K", email: "credentials@globaltech.com",  phone: "+1 555 0200", submittedDate: "2026-02-28", panCopy: "Available", gstCertificate: "Available", tanCertificate: "Pending",   status: "Pending" },
  { id: "req-3", client: "Enterprise Dynamics",   corporateName: "Enterprise Dynamics LLC",      panNumber: "KLMNO9012L", email: "admin@entdynamics.com",       phone: "+1 555 0300", submittedDate: "2026-02-25", panCopy: "Available", gstCertificate: "Available", tanCertificate: "Available", status: "Accepted" },
  { id: "req-4", client: "Innovation Partners",   corporateName: "Innovation Partners Group",    panNumber: "PQRST3456M", email: "info@innovationpartners.com", phone: "+1 555 0400", submittedDate: "2026-02-20", panCopy: "Available", gstCertificate: "Pending",   tanCertificate: "Pending",   status: "Rejected" },
];

const DocStatus = ({ status, label, clientId }) => {
  if (status === "Available") return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-green-700 font-medium">Available</span>
      <button onClick={() => alert(`Downloading ${label} for client ${clientId}`)} className="p-1 hover:bg-gray-100 rounded" title={`Download ${label}`}>
        <Download className="w-3.5 h-3.5 text-gray-500" />
      </button>
    </div>
  );
  return <span className="text-xs text-yellow-700 font-medium">Pending</span>;
};

export default function CredentialsPage() {
  const [showInvite, setShowInvite] = useState(false);
  const [form, setForm]             = useState({ name: "", email: "", role: "Admin", phone: "" });

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="flex items-center justify-between mb-6 flex-wrap gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900">Credential Requests</h1>
          <p className="text-sm text-gray-500 mt-1">Manage client onboarding and credential approvals</p>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={() => alert("Downloading all documents...")} className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium">
            <Download className="w-4 h-4" /> Download All Docs
          </button>
          <button onClick={() => setShowInvite(true)} className="flex items-center gap-2 px-4 py-2 bg-[#367588] text-white rounded-lg hover:bg-[#2a5a6b] transition-colors text-sm font-medium">
            <UserPlus className="w-4 h-4" /> Invite Teammate
          </button>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                {["Corporate Name","PAN","Email","Phone","Submitted","PAN Copy","GST Certificate","TAN Certificate","Status","Actions"].map(h => (
                  <th key={h} className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {credentialsData.map(r => (
                <tr key={r.id} className="hover:bg-gray-50">
                  <td className="px-4 py-4">
                    <p className="text-sm font-medium text-gray-900">{r.corporateName}</p>
                    <p className="text-xs text-gray-500">{r.client}</p>
                  </td>
                  <td className="px-4 py-4 text-sm font-mono text-gray-700">{r.panNumber}</td>
                  <td className="px-4 py-4 text-sm text-gray-700">{r.email}</td>
                  <td className="px-4 py-4 text-sm text-gray-700 whitespace-nowrap">{r.phone}</td>
                  <td className="px-4 py-4 text-sm text-gray-700 whitespace-nowrap">{r.submittedDate}</td>
                  <td className="px-4 py-4"><DocStatus status={r.panCopy}         label="PAN Copy"         clientId={r.id} /></td>
                  <td className="px-4 py-4"><DocStatus status={r.gstCertificate}  label="GST Certificate"  clientId={r.id} /></td>
                  <td className="px-4 py-4"><DocStatus status={r.tanCertificate}  label="TAN Certificate"  clientId={r.id} /></td>
                  <td className="px-4 py-4"><StatusBadge status={r.status} type="request" /></td>
                  <td className="px-4 py-4">
                    {r.status === "Pending" && (
                      <div className="flex gap-2">
                        <button onClick={() => alert(`Approved: ${r.corporateName}`)} className="flex items-center gap-1 px-2.5 py-1 bg-green-100 text-green-700 rounded text-xs font-medium hover:bg-green-200 transition-colors">
                          <Check className="w-3 h-3" /> Approve
                        </button>
                        <button onClick={() => alert(`Rejected: ${r.corporateName}`)} className="flex items-center gap-1 px-2.5 py-1 bg-red-100 text-red-700 rounded text-xs font-medium hover:bg-red-200 transition-colors">
                          <X className="w-3 h-3" /> Reject
                        </button>
                      </div>
                    )}
                    {r.status !== "Pending" && (
                      <button onClick={() => alert(`Downloading all docs for ${r.corporateName}`)} className="flex items-center gap-1 px-2.5 py-1 bg-gray-100 text-gray-700 rounded text-xs font-medium hover:bg-gray-200 transition-colors">
                        <Download className="w-3 h-3" /> Download
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Invite modal */}
      {showInvite && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" onClick={() => setShowInvite(false)}>
          <div className="bg-white rounded-xl max-w-md w-full" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between p-5 border-b border-gray-200">
              <h3 className="font-semibold text-gray-900">Invite Teammate</h3>
              <button onClick={() => setShowInvite(false)}><X className="w-5 h-5 text-gray-400" /></button>
            </div>
            <div className="p-5 space-y-4">
              {[["name","Full Name","text","Enter full name"],["email","Email Address","email","Enter email"],["phone","Phone Number","tel","Enter phone"]].map(([key,label,type,ph]) => (
                <div key={key}>
                  <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
                  <input type={type} value={form[key]} onChange={e => setForm({...form, [key]: e.target.value})} placeholder={ph}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#367588] focus:border-transparent outline-none text-sm" />
                </div>
              ))}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
                <select value={form.role} onChange={e => setForm({...form, role: e.target.value})} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#367588] focus:border-transparent outline-none text-sm">
                  <option>Admin</option><option>Reviewer</option><option>Manager</option>
                </select>
              </div>
              <div className="flex gap-3 pt-2">
                <button onClick={() => { alert(`Invite sent to ${form.email}`); setShowInvite(false); }} className="flex-1 bg-[#367588] text-white py-2.5 rounded-lg font-semibold hover:bg-[#2a5a6b] transition-colors text-sm">Send Invite</button>
                <button onClick={() => setShowInvite(false)} className="flex-1 border border-gray-300 text-gray-700 py-2.5 rounded-lg font-semibold hover:bg-gray-50 transition-colors text-sm">Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
